/**
 * Mobile / PII display.
 *
 * The server already masks every mobile number in its responses unless the
 * logged-in user has full-PII access (org switch on + user flag, or
 * superadmin) — see lms util/piiAccess.js. The browser mask here is a second
 * layer for values that arrive by other paths (SSE events, cached state), and
 * it steps aside when the login payload says the user may see full numbers.
 */
export const hasPiiAccess = (user) => user?.piiAccess === true;

export const maskPhone = (num, user) => {
  if (num === null || num === undefined || num === '') return 'N/A';
  const s = String(num);
  if (hasPiiAccess(user)) return s;
  if (s.length <= 3) return s;
  return s.slice(0, 3) + '*'.repeat(s.length - 3);
};
